import React, { useState, useEffect, useRef } from "react";
import { useFormInputValidation } from "react-form-input-validation";
import RegisterService from '../services/register-service';
import { json, useNavigate, useParams, useLocation } from "react-router-dom";
import { ColorRing } from 'react-loader-spinner'
import "../css/captcha.css";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha
} from "react-simple-captcha";
import { toastMsg } from '../utils/ApiHelper';

function RegisterComponent(props){
    const { micrositePath } = props;
    const navigate = useNavigate();
    const useQueryString = () => {
        const location = useLocation();
        return new URLSearchParams(location.search);
    }
    const queryString = useQueryString();
    let utm_param = queryString.get('utm_source');
    let utm_source='microsite';
    const captchaRef1 = useRef(null);
    const [btn_disable, setBtnDisable] = useState(false);
    const MINUTE_MS = 6000;//10 sec 
    const [fields, errors, form] = useFormInputValidation({
        first_name: "",
        last_name:"",
        email:"",
        contact_number:"",
        member_2_full_name:"",
        member_2_email:"",
        member_2_phone_no:"",
        city:"",
        terms:"",
        captcha:""
    }, {
        first_name: "required|max:30|min:3",
        last_name:"required|only_letters|max:30|min:3",
        email:"required|email",
        contact_number:"required|numeric|digits:10",
        member_2_full_name:"required|only_letters|max:30|min:3",
        member_2_email:"required|email",
        member_2_phone_no:"required|numeric|digits:10",
        city:"required",
        terms:"required",
        captcha:"required"
    });

    

      useEffect(() => {
        loadCaptchaEnginge(8);
      },[captchaRef1]);
      
     
      const onSubmitForm = async (event) => {
      
        event.preventDefault();
        const isValid = await form.validate(event);
        let user_captcha = captchaRef1.current.value;
        if (isValid) {
            if (validateCaptcha(user_captcha)) {
                if(utm_param){
                    utm_source = utm_param;
                }
                console.log('isValid',isValid);
                setBtnDisable(true);
                let payload={
                "first_name":fields.first_name,
                "last_name":fields.last_name,
                "email":fields.email,
                "contact_number":fields.contact_number,
                "member_2_full_name":fields.member_2_full_name,
                "member_2_email":fields.member_2_email,
                "member_2_phone_no":fields.member_2_phone_no,
                "city":fields.city,
                "microsite_path":micrositePath,
                "terms":1,
                "UTM_source":utm_source
                }
              async function saveBasicDetails() {
                
                    let data = await RegisterService.setRegisterFormData(payload);
                    if(!data){
                        setTimeout(() => {
                            setBtnDisable(false);
                        }, MINUTE_MS);
                        return false;
                    }
                    
                setTimeout(() => {
                    window.location.reload();
                    setBtnDisable(false);
                }, MINUTE_MS);
               }
               saveBasicDetails(); 
           
       
            }else{
                toastMsg('Captcha Does Not Match', 'error');
                document.getElementById("user_captcha_input").value = "";
            }
        }else{
            // toastMsg('please fill all mandatory fields', 'error');
            loadCaptchaEnginge(6);
            document.getElementById("user_captcha_input").value = "";
        }      
            
        
    }

    useEffect(() => {
        form.registerAsync("only_letters", function (
          str,
          attribute,
          req,
          passes
        ) {
            var specials = /[^A-Za-z \s]/g;
            if (specials.test(str))
              passes(false, "Only letters allow.");
            else passes();
        });
      }, []);

    return(     
        <>
        
                    <div className="nw18-right-content" id="registration">
                        <h3 className="nw18-register-title">
                        REGISTRATION CLOSED
                        </h3>
                        
                        <div className="nw18-form-wrapper">
                            <div className="nw18-new-register">
                            
                                <form action="" id="registerForm" onSubmit={onSubmitForm}>
                                    
                                    <div className="nw18-form-div">
                                        <input type="text" disabled name="first_name" placeholder="Team Name" onBlur={form.handleBlurEvent} onChange={form.handleChangeEvent} data-attribute-name="Team Name" data-async
 id="first_name" />
                                        <label className="error"> {errors.first_name ? errors.first_name : ""} </label>
                                    </div>
                                    <div className="nw18-form-div">
                                        <input type="text" disabled name="last_name" placeholder="Member#1:Full Name" onBlur={form.handleBlurEvent} onChange={form.handleChangeEvent} data-attribute-name="Member-1:Full Name" data-async
 id="first_name" />
                                        <label className="error"> {errors.last_name ? errors.last_name : ""} </label>
                                    </div>
                                    <div className="nw18-form-div">
                                        <input type="text" disabled name="email" placeholder="Member#1:Email" id="email" onBlur={form.handleBlurEvent} onChange={form.handleChangeEvent} data-attribute-name="Member-1:Email" data-async/>
                                        <label className="error"> {errors.email ? errors.email : ""} </label>
                                    </div>
                                    <div className="nw18-form-div">
                                        <input type="text" disabled name="contact_number" placeholder="Member#1:Contact Number" id="contact_number" onBlur={form.handleBlurEvent} onChange={form.handleChangeEvent} data-attribute-name="Member-1:Contact Number" data-async/>
                                        <label className="error"> {errors.contact_number ? errors.contact_number : ""} </label>
                                    </div>
                                    
                                    <div className="nw18-form-div">
                                        <input type="text" disabled name="member_2_full_name" placeholder="Member#2:Full Name" id="member_2_full_name" onBlur={form.handleBlurEvent} onChange={form.handleChangeEvent} data-attribute-name="Member-2:Full Name" data-async/>
                                        <label className="error"> {errors.member_2_full_name ? errors.member_2_full_name : ""} </label>
                                    </div>
                                    <div className="nw18-form-div">
                                        <input type="text" disabled name="member_2_email" placeholder="Member#2:Email" id="member_2_email" onBlur={form.handleBlurEvent} onChange={form.handleChangeEvent} data-attribute-name="Member-2:Email" data-async/>
                                        <label className="error"> {errors.member_2_email ? errors.member_2_email : ""} </label>
                                    </div>
                                    <div className="nw18-form-div">
                                        <input type="text" disabled name="member_2_phone_no" placeholder="Member#2:Contact Number" id="member_2_phone_no" onBlur={form.handleBlurEvent} onChange={form.handleChangeEvent} data-attribute-name="Member-2:Contact Number" data-async/>
                                        <label className="error"> {errors.member_2_phone_no ? errors.member_2_phone_no : ""} </label>
                                    </div>
                                    <div className="nw18-form-div">
                                        <input type="text" disabled name="city" placeholder="City" id="city" onBlur={form.handleBlurEvent} onChange={form.handleChangeEvent} data-attribute-name="City" data-async/>
                                        <label className="error"> {errors.city ? errors.city : ""} </label>
                                    </div>
                                    
                                    <div className="nw18-terms-div form-div">
                                        <input type="checkbox" disabled name="terms" id="terms" onBlur={form.handleBlurEvent} onChange={form.handleChangeEvent}></input>
                                        <label htmlFor="terms">By submitting this form, you are agreeing to Network18 and the event partner contacting you with marketing related emails or calls. Network18 websites and communications are subject to our privacy policy and terms of use.
</label>
                                    </div>
                                    <label className="error"> {errors.terms ? errors.terms : ""} </label>
                                    
                                     <br/>
                                    <div className="nw18-form-div">
                                    <LoadCanvasTemplate  />
                                    <input ref={captchaRef1} disabled type="text" name="user_captcha_input" id="user_captcha_input" />
                                    </div> 
                                    <label className="error"> {errors.captcha ? errors.captcha : ""} </label>
                                    <div className="nw18-form-div nw18-register-btn-div">
                                    {(btn_disable) ? ( <ColorRing
                                                        visible={true}
                                                        height="80"
                                                        width="80"
                                                        ariaLabel="blocks-loading"
                                                        wrapperStyle={{}}
                                                        wrapperClass="blocks-wrapper"
                                                        colors={['#2A426E','#2A426E','#2A426E','#2A426E','#2A426E']}
                                                    />) : ( <button type="button" className="nw18-register-btn">REGISTRATION CLOSED</button>)}
                                    </div>
                                </form>
          
                            </div>
                        </div>   
                    </div>
                    
                    </>
                    
        )
}
export default RegisterComponent;